import Config from 'conf';
import { Logger, Toastr } from 'data/common';
import eventsEntities from '../eventsSocket';
import Translator from '../../../../../translator';

const { EventEmitter } = require('events');
const util = require('util');

let io = require('socket.io-client');

function SocketMiddleware(_dispatch, _getState, token, _middleware_config, session) {
    return initConnexion.call(this, _dispatch, _getState, token, _middleware_config, session);
}

const initConnexion = function initConnexion(_dispatch, _getState, token, _middleware_config) {
    if (_dispatch && _getState && token) {
        EventEmitter.call(this);
        this.middleware_config = _middleware_config;
        this.socket_connected = false;
        this.dispatch = _dispatch;
        this.getState = _getState;

        this.timeout_connexion = setTimeout(() => {
            this.emit('cnx_error', 'timeout_connexion');
            this.dispatch({
                type: 'FHE__MIDDLEWARE_SET_CONNEXION_STATE',
                state: 'disconnected',
                mid: this.middleware_config.mid,
                label: this.middleware_config.label
            });
        }, Config.timeout_socket);

        this.dispatch({
            type: 'FHE__MIDDLEWARE_SET_CONNEXION_STATE',
            state: 'pending',
            mid: this.middleware_config.mid,
            label: this.middleware_config.label
        });
        this.socket = io(this.middleware_config.protocol + '://' + this.middleware_config.host + ':' + this.middleware_config.port, {
            timeout: 30000,
            ...this.middleware_config.options,
            query: `type=client&token=${token}&authid=${this.middleware_config.authBySession ? localStorage.getItem('session') : token}`
        });
        this.socket.on('connect_error', () => {
            if (location.protocol !== this.middleware_config.protocol + ':') {
                if (sessionStorage.getItem('mixedContentNoticeIsClicked') !== 'true') {
                    Toastr.notice({
                        content: Translator.translate('general.mixedContentWarning', '<i style="color: red" class="fas fa-shield-alt" />'),
                        title: Translator.translate('general.importantNotice'),
                        onClick: () => sessionStorage.setItem('mixedContentNoticeIsClicked', 'true')
                    });
                }
            }
        });

        Logger.debug(
            `Fhe (${this.middleware_config.label}) : Lancement de la connexion au Middleware ${this.middleware_config.protocol}://${this.middleware_config.host}:${this.middleware_config.port}`,
            {
                timeout: 30000,
                ...this.middleware_config.options,
                query: `type=client&authid=${this.middleware_config.authBySession ? localStorage.getItem('session') : token}`
            }
        );
        let eventsSocket = eventsEntities(this);

        Object.keys(eventsSocket).map(fctKey => {
            this[fctKey] = eventsSocket[fctKey];
        });

        this.bindSocketEvents();
    }
};
util.inherits(SocketMiddleware, EventEmitter);

SocketMiddleware.prototype.socketEmit = function(event, params) {
    if (this.socket && this.socket_connected) {
        try {
            this.socket.emit(event, params);
            Logger.debug(`Fhe (${this.middleware_config.label}) : Socket Event Emitted "${event}" --->`, params);
        } catch (e) {
            Logger.debug(`Fhe (${this.middleware_config.label}) : Error emit socket event "${event}" --->`, e.message);
            throw e;
        }
    } else {
        throw new Error('middlewareConnectionBreak');
    }
};

SocketMiddleware.prototype.bindSocketEvents = function() {
    let self = this;

    if (!self.socket) {
        Logger.debug(`Fhe (${self.middleware_config.label}) : Problème, la socket n'existe pas vraiment !`);
        return false;
    }

    this.socketOn('error', function() {
        if (self.timeout_connexion) clearTimeout(self.timeout_connexion);
        const error_code = arguments[0].message || arguments[0];
        Logger.error(`Fhe (${self.middleware_config.label}) : Error Middleware`, error_code);
        self.dispatch({
            type: 'FHE__MIDDLEWARE_SET_CONNEXION_STATE',
            state: 'disconnected',
            mid: self.middleware_config.mid,
            label: self.middleware_config.label
        });
    });

    this.socketOn('connect', function() {
        self.socket_connected = true;
        clearTimeout(self.timeout_connexion);
        self.timeout_connexion = null;
        Logger.debug(`Fhe (${self.middleware_config.label}) : La socket est créée`);
        self.emit('connected');
        self.dispatch({
            type: 'FHE__MIDDLEWARE_SET_CONNEXION_STATE',
            state: 'connected',
            mid: self.middleware_config.mid,
            label: self.middleware_config.label
        });
    });

    this.socketOn('connected', function() {
        Logger.debug(`Fhe (${self.middleware_config.label}) : L'application vient de se connecter au middleware Fhe`);
    });

    this.socketOn('disconnect', function() {
        self.socket_connected = false;
        Logger.debug(`Fhe (${self.middleware_config.label}) : L'application vient de se déconnecter du middleware Fhe`);
        self.emit('disconnect');
        self.dispatch({
            type: 'FHE__MIDDLEWARE_SET_CONNEXION_STATE',
            state: 'disconnected',
            mid: self.middleware_config.mid,
            label: self.middleware_config.label
        });
    });
};

SocketMiddleware.prototype.socketOn = function socketOn(event, callback) {
    if (this.socket) {
        this.socket.on(event, callback);
    }
};

SocketMiddleware.prototype.disconnect = function() {
    try {
        if (this.socket) {
            this.socket.disconnect();
        } else {
            Logger.debug(`Fhe (${this.middleware_config.label}) : Impossible de déconnecter la socket`);
        }
    } catch (e) {
        Logger.warn(`Fhe (${this.middleware_config.label}) : ${e}`);
    }
    this.socket = null;
};

SocketMiddleware.prototype.off = function(event, func) {
    if (this.socket) {
        this.socket.removeListener(event, func);
    }
};

SocketMiddleware.prototype.destroy = function() {
    try {
        Logger.debug(`Fhe (${this.middleware_config.label}) : Destruction socketMiddleware`);
        this.dispatch({
            type: 'FHE_MIDDLEWARE_SET_CONNEXION_STATE',
            state: null,
            mid: this.middleware_config.mid,
            label: this.middleware_config.label
        });
        this.disconnect();
    } catch (e) {
        Logger.warn(`Fhe (${this.middleware_config.label}) : ${e}`);
    }
};

export default function(dispatch, getState, token, _middleware_config, session) {
    // this.middleware_config = _middleware_config;
    return new SocketMiddleware(dispatch, getState, token, _middleware_config, session);
}



// WEBPACK FOOTER //
// ./environments/fhe/common/SocketMiddleware.js